import { useEffect, useState } from "react";

import toast from "react-hot-toast";

import { getTenant } from "../../../utils/tenantManager";

import {
  createRepairQuotationApi,
  deleteRepairQuotationApi,
  getRepairQuotationByIdApi,
  getRepairQuotationsApi,
  updateRepairQuotationApi,
} from "../../../services/operation/repairquotation/repairQuotationService";

export const useRepairQuotationViewModel = () => {
  const tenantId = getTenant();

  const [repairQuotations, setRepairQuotations] = useState<any[]>([]);

  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(1);

  const [search, setSearch] = useState("");

  const [totalCount, setTotalCount] = useState(0);

  // ================= LOAD =================
  const loadRepairQuotations = async () => {
    try {
      setLoading(true);

      const res = await getRepairQuotationsApi(page, 10, search, tenantId!);

      setRepairQuotations(res?.data?.data || []);

      setTotalCount(res?.data?.totalCount || 0);
    } catch {
      toast.error("Failed to load quotations");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadRepairQuotations();
  }, [page, search]);

  // ================= GET ONE =================
  const getRepairQuotationById = async (id: string) => {
    try {
      const res = await getRepairQuotationByIdApi(id, tenantId!);

      return res?.data;
    } catch {
      toast.error("Failed to load quotation");
    }
  };

  // ================= CREATE =================
  const createRepairQuotation = async (data: any) => {
    try {
      const res = await createRepairQuotationApi(data, tenantId!);

      if (res?.success) {
        toast.success("Quotation created");

        loadRepairQuotations();

        return true;
      }

      return false;
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Create failed");

      return false;
    }
  };

  // ================= UPDATE =================
  const updateRepairQuotation = async (data: any) => {
    try {
      const res = await updateRepairQuotationApi(data, tenantId!);

      if (res?.success) {
        toast.success("Quotation updated");

        loadRepairQuotations();

        return true;
      }

      return false;
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Update failed");

      return false;
    }
  };

  // ================= DELETE =================
  const deleteRepairQuotation = async (id: string) => {
    try {
      const res = await deleteRepairQuotationApi(id, tenantId!);

      if (res?.success) {
        toast.success("Quotation deleted");

        loadRepairQuotations();
      }
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Delete failed");
    }
  };

  return {
    repairQuotations,
    loading,

    page,
    setPage,

    search,
    setSearch,

    totalCount,

    createRepairQuotation,

    getRepairQuotationById,

    updateRepairQuotation,

    deleteRepairQuotation,
  };
};
